import { gql } from "@apollo/client"

export const UpdateBrand = gql`
mutation Mutation($updateBrandId: ID!, $content: contentBrand!) {
  updateBrand(id: $updateBrandId, content: $content) {
    status
  }
}
`